/* eslint-disable @angular-eslint/prefer-standalone */
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PoNotificationService } from '@po-ui/ng-components';
import { Subscription } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { Functions } from '../../functions/functions';
@Component({
  selector: 'tgv-filter',
  standalone: false,
  templateUrl: './filter.component.html'
})
export class FilterComponent implements OnInit, OnDestroy {
  @Output() filterValue: EventEmitter<string> = new EventEmitter();
  @Input() description: string;
  @Input() error: string;
  @Input() literals: LiteralsWords;
  @Input() regexMaskFilter = new RegExp(/["'?%$]/g);
  @Input() canFormatDate = true;
  searchInput: UntypedFormGroup;
  searchInput$ = new Subscription();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private poNotification: PoNotificationService,
    private datePipe: DatePipe,
    private functions: Functions
  ) {}

  ngOnDestroy(): void {
    this.searchInput$.unsubscribe();
  }

  ngOnInit(): void {
    this.onFormInit();
    this.changeInput();
  }

  onFormInit(): void {
    this.searchInput = this.formBuilder.group({
      search: ['']
    });
  }

  changeInput(): void {
    this.searchInput$ = this.searchInput.valueChanges
    .pipe(
      debounceTime(1000),
      map(searchForm => searchForm.search != null ? this.handleRegexAndChangeFilterString(searchForm.search) : ''),
      filter(valueSearch => valueSearch.length >= 3 || !valueSearch.length)
    )
    .subscribe({
      next: searchForm => this.validEmptySearch(searchForm),
      error: error => this.poNotification.error(this.error + ' ' + error)
    });
  }

  validEmptySearch(search: string): void {
    if (search) {
      this.filterSearchInput(search);
    } else {
      this.filterValue.emit(search);
    }
  }

  filterSearchInput(search: string): void {
    if (this.functions.isDate(search)) {
      this.filterDate(search);
    } else {
      this.filterString(search);
    }
  }

  filterString(search: string): void {
    this.filterValue.emit(search);
  }

  filterDate(search: string): void {
    if (search.length < 8) {
      return this.poNotification.information(
        this.literals.str0200
      );
    }
    if (this.canFormatDate) {
      this.transformDate(search);
    } else {
      this.filterString(search);
    }
  }

  transformDate(search: string): void {
    const dateSearch = search.split('/');
    const dateFormated = new Date(
      +dateSearch[2],
      +dateSearch[1] - 1,
      +dateSearch[0]
    )
      .toISOString();

    this.filterValue.emit(this.datePipe.transform(dateFormated, 'yyyy-M-d'));
  }

  handleRegexAndChangeFilterString(search: string): string {
    if (this.functions.isDate(search)) {
      return search;
    } else {
      const searchReturn = this.functions.returnStringWithRegex(
        search,
        this.regexMaskFilter
      );
      this.searchInput.patchValue(
        { search: searchReturn },
        { emitEvent: false }
      );
      return searchReturn;
    }
  }
}
